import { FC, PropsWithChildren } from 'react'

// Historical wrapper component. Scroll-to-top on route change is now
// handled globally by <ScrollToTopOnSpaNav> mounted in App.tsx, so this is
// a pass-through. Existing imports are left intact to avoid sprawling
// churn; new code should not use this component.
const ScrollTop: FC<PropsWithChildren> = ({ children }) => <>{children}</>

export default ScrollTop
